import { useCallback, useEffect, useState } from 'react';

export function useCompanyFundsTableState() {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageInputValue, setPageInputValue] = useState('1');

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage((prev) => {
      const next = Math.max(1, page);
      setPageInputValue(String(next));
      return next;
    });
  }, []);

  const handleRowsPerPageChange = useCallback((value: string) => {
    const newRowsPerPage = parseInt(value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
    setPageInputValue('1');
  }, []);

  const handlePageInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setPageInputValue(e.target.value);
  }, []);

  const handlePageInputBlur = useCallback(() => {
    const page = parseInt(pageInputValue, 10);
    if (!isNaN(page) && page !== currentPage) {
      handlePageChange(page);
    } else {
      setPageInputValue(String(currentPage));
    }
  }, [currentPage, pageInputValue, handlePageChange]);

  const setPaginationFromCount = useCallback((count: number) => {
    setTotalCount(count || 0);
    setTotalPages(Math.ceil((count || 0) / rowsPerPage) || 1);
  }, [rowsPerPage]);

  const ensurePageWithinBounds = useCallback((count: number) => {
    const newTotalPages = Math.ceil((count || 0) / rowsPerPage) || 1;
    if (currentPage > newTotalPages && count > 0) {
      const newPage = Math.max(1, newTotalPages);
      setCurrentPage(newPage);
      setPageInputValue(String(newPage));
    }
  }, [currentPage, rowsPerPage]);

  return {
    currentPage,
    rowsPerPage,
    totalPages,
    totalCount,
    pageInputValue,
    setPaginationFromCount,
    ensurePageWithinBounds,
    handlePageChange,
    handleRowsPerPageChange,
    handlePageInputChange,
    handlePageInputBlur,
  };
}
